module.exports = __webpack_public_path__ + "images/icons_v2/thumbs-down-filled-77089ca3.svg";